export const CONTAINER_TO_SCREEN_WIDTH_RATE = 0.9;
